import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { TooltipToggle, TooltipContent } from 'components/Tooltip';

import Button from 'components/Button';
import Message from 'components/Message';

import './StaffAccountItem.scss';

export const messages = defineMessages({
  numberOfVenues: {
    id: 'staff-accounts.item.number-of-venues',
    defaultMessage: '{venues, plural, one {# venue} other {# venues}}',
  },
  editLabel: { id: 'staff-accounts.item.card.edit-label', defaultMessage: 'Edit' },
  you: {
    id: 'staff-accounts.item.card.you',
    defaultMessage: '(You)',
  },
});

const StaffAccountItem = ({
  account: { firstName, lastName, email, venues, userId, editable },
  currentUserId,
  openModal,
}) => {
  const userName = `${firstName} ${lastName}`.trim();

  return (
    <div className="staff-account-item">
      <div className="staff-account-item__header">
        <div className="staff-account-item__name">
          {userName}
          {currentUserId === userId && <Message className="staff-account-item__you-label" message={messages.you} />}
        </div>
        {(editable || currentUserId === userId) && (
          <Message
            as={Button}
            onClick={openModal}
            styled="primary-outline"
            className="staff-account-item__edit-button"
            type={Button.TYPES.BUTTON}
            message={messages.editLabel}
          />
        )}
      </div>
      <div className="staff-account-item__mail">{email}</div>
      <span>
        <TooltipToggle name={`tooltip-staff-${userId}-venues`} className="staff-account-item__tooltip">
          <Message
            values={{ venues: venues.length }}
            className="staff-account-item__venues"
            message={messages.numberOfVenues}
          />
        </TooltipToggle>
        <TooltipContent
          className="staff-account-item__tooltip-content"
          name={`tooltip-staff-${userId}-venues`}
          place="right"
          hoverable>
          {venues &&
            venues.map(({ venueId, venueName, venueSubtitle, venueAliasUrl }) => (
              <li key={venueId}>
                <a href={venueAliasUrl} rel="noopener noreferrer" target="_blank">
                  {venueSubtitle ? `${venueName} (${venueSubtitle})` : venueName}
                </a>
              </li>
            ))}
        </TooltipContent>
      </span>
    </div>
  );
};

StaffAccountItem.propTypes = {
  account: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    venues: PropTypes.arrayOf(PropTypes.shape({ venueId: PropTypes.number, venueName: PropTypes.string })),
    userId: PropTypes.number,
    editable: PropTypes.bool,
  }),
  currentUserId: PropTypes.number,
  openModal: PropTypes.func,
};

export default StaffAccountItem;
